import { title } from 'process';
import { StyleSheet } from 'react-native';
import Theme from 'Theme';

let baseStyles = {
    pressable: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        borderRadius: 12,
        width: 150,
        height: 170,
        zIndex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    foccusedPressable: {
        backgroundColor: Theme.primaryActiveColor,
        borderRadius: 12,
        width: 150,
        height: 170,
        zIndex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    card: {
        zIndex: 4,
        width: 47,
        height: 38,
        color: 'white',
        top: 27,
        marginBottom: 15
    },
    product: {
        zIndex: 4,
        width: 37,
        height: 48,
        color: 'white',
        top: 27,
        marginBottom: 15
    },
    buttonTitle: {
        color: 'white',
        marginTop: 10,
        fontSize: 18,
        zIndex: 2,
        maxWidth: 130,
        textAlign: 'center',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        overflowWrap: 'break-word'
    },
    buttonTitleWidth: {
        maxWidth: 110
    }
};

export default StyleSheet.create(baseStyles);
